module.exports = __webpack_public_path__ + "static/media/partial-timesheet.43d5fa95.svg";